module.exports = __webpack_public_path__ + "static/media/eye-dropper.4113a08f.svg";